import React from 'react';
import { SparklesIcon, TrendingUpIcon, ZapIcon, CheckCircleIcon } from 'lucide-react';
const ProductUpdatesEmail = () => {
  return <div className="min-h-screen bg-gray-50 py-12 px-4" data-id="element-1341">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1342">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 to-blue-600 px-8 py-12 text-center" data-id="element-1343">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1344">
            <SparklesIcon size={32} className="text-purple-600" data-id="element-1345" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-1346">
            Nuevas funcionalidades disponibles
          </h1>
          <p className="text-purple-100 text-lg" data-id="element-1347">
            Actualización de producto - Enero 2024
          </p>
        </div>
        {/* Content */}
        <div className="px-8 py-10" data-id="element-1348">
          <div className="mb-8" data-id="element-1349">
            <p className="text-gray-700 text-lg mb-4" data-id="element-1350">Hola Ana,</p>
            <p className="text-gray-700 mb-4" data-id="element-1351">
              Nos emociona compartir contigo las últimas mejoras que hemos
              implementado en <strong data-id="element-1352">FinancePro</strong> para hacer tu
              experiencia aún mejor.
            </p>
          </div>
          {/* New Features */}
          <div className="mb-8" data-id="element-1353">
            <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-1354">
              ✨ Novedades destacadas
            </h2>
            <div className="space-y-6" data-id="element-1355">
              {/* Feature 1 */}
              <div className="border border-purple-200 rounded-lg overflow-hidden" data-id="element-1356">
                <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-6" data-id="element-1357">
                  <div className="flex items-start space-x-4" data-id="element-1358">
                    <div className="w-12 h-12 rounded-lg bg-purple-600 flex items-center justify-center flex-shrink-0" data-id="element-1359">
                      <TrendingUpIcon size={24} className="text-white" data-id="element-1360" />
                    </div>
                    <div className="flex-1" data-id="element-1361">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1362">
                        Análisis predictivo con IA
                      </h3>
                      <p className="text-gray-700 mb-4" data-id="element-1363">
                        Ahora puedes visualizar proyecciones de tus finanzas
                        basadas en inteligencia artificial. Obtén predicciones
                        de ventas, gastos y flujo de caja para los próximos 3, 6
                        y 12 meses.
                      </p>
                      <div className="flex flex-wrap gap-2" data-id="element-1364">
                        <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium" data-id="element-1365">
                          Predicciones automáticas
                        </span>
                        <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium" data-id="element-1366">
                          Escenarios múltiples
                        </span>
                        <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium" data-id="element-1367">
                          Recomendaciones personalizadas
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Feature 2 */}
              <div className="border border-blue-200 rounded-lg overflow-hidden" data-id="element-1368">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6" data-id="element-1369">
                  <div className="flex items-start space-x-4" data-id="element-1370">
                    <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0" data-id="element-1371">
                      <ZapIcon size={24} className="text-white" data-id="element-1372" />
                    </div>
                    <div className="flex-1" data-id="element-1373">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1374">
                        Reportes personalizados
                      </h3>
                      <p className="text-gray-700 mb-4" data-id="element-1375">
                        Crea reportes completamente personalizados con los
                        indicadores que más te importan. Guarda tus plantillas
                        favoritas y genera reportes en segundos.
                      </p>
                      <div className="flex flex-wrap gap-2" data-id="element-1376">
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium" data-id="element-1377">
                          Drag & drop
                        </span>
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium" data-id="element-1378">
                          Exportar PDF/Excel
                        </span>
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium" data-id="element-1379">
                          Plantillas guardadas
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Feature 3 */}
              <div className="border border-green-200 rounded-lg overflow-hidden" data-id="element-1380">
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6" data-id="element-1381">
                  <div className="flex items-start space-x-4" data-id="element-1382">
                    <div className="w-12 h-12 rounded-lg bg-green-600 flex items-center justify-center flex-shrink-0" data-id="element-1383">
                      <CheckCircleIcon size={24} className="text-white" data-id="element-1384" />
                    </div>
                    <div className="flex-1" data-id="element-1385">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1386">
                        Integración con Contalink
                      </h3>
                      <p className="text-gray-700 mb-4" data-id="element-1387">
                        Conecta tu cuenta de Contalink para sincronizar
                        automáticamente tus datos contables. Ahora soportamos
                        QuickBooks, Xero, SAP y Contalink.
                      </p>
                      <div className="flex flex-wrap gap-2" data-id="element-1388">
                        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium" data-id="element-1389">
                          Sincronización automática
                        </span>
                        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium" data-id="element-1390">
                          Datos en tiempo real
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Improvements */}
          <div className="bg-gray-50 rounded-lg p-6 mb-8" data-id="element-1391">
            <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1392">
              🚀 Mejoras adicionales
            </h2>
            <ul className="space-y-2" data-id="element-1393">
              <li className="flex items-start space-x-3" data-id="element-1394">
                <CheckCircleIcon size={20} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-1395" />
                <span className="text-gray-700" data-id="element-1396">
                  Dashboard más rápido con carga optimizada de gráficos
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1397">
                <CheckCircleIcon size={20} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-1398" />
                <span className="text-gray-700" data-id="element-1399">
                  Nuevos filtros avanzados en todos los reportes
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1400">
                <CheckCircleIcon size={20} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-1401" />
                <span className="text-gray-700" data-id="element-1402">
                  Modo oscuro disponible en configuración
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1403">
                <CheckCircleIcon size={20} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-1404" />
                <span className="text-gray-700" data-id="element-1405">
                  Notificaciones push para alertas críticas
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1406">
                <CheckCircleIcon size={20} className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-1407" />
                <span className="text-gray-700" data-id="element-1408">
                  Aplicación móvil mejorada (iOS y Android)
                </span>
              </li>
            </ul>
          </div>
          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-1409">
            <a href="/" className="inline-block bg-purple-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors mb-3" data-id="element-1410">
              Explorar nuevas funciones
            </a>
            <p className="text-sm text-gray-600" data-id="element-1411">
              ¿Tienes preguntas?{' '}
              <a href="#" className="text-purple-600 hover:text-purple-700" data-id="element-1412">
                Ver documentación completa
              </a>
            </p>
          </div>
          {/* Feedback */}
          <div className="border-t border-gray-200 pt-6" data-id="element-1413">
            <p className="text-gray-700 mb-2" data-id="element-1414">
              Tu opinión es muy importante para nosotros.
            </p>
            <p className="text-gray-600 text-sm" data-id="element-1415">
              Comparte tus comentarios sobre estas actualizaciones en{' '}
              <a href="mailto:feedback@financepro.com" className="text-blue-600 hover:text-blue-700" data-id="element-1416">
                feedback@financepro.com
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200" data-id="element-1417">
          <p className="text-center text-gray-600 text-sm mb-2" data-id="element-1418">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
          <p className="text-center text-gray-500 text-xs" data-id="element-1419">
            Recibiste este correo porque tienes activadas las notificaciones de
            actualizaciones.
          </p>
        </div>
      </div>
    </div>;
};
export default ProductUpdatesEmail;